import { template } from "@ember/template-compiler";
import RouteTemplate from 'ember-route-template';
import WrModalContent from 'ember-wiser/components/wr/modal/content';
import LoginPasswordCreationInstructions, { Signature as LoginPasswordCreationInstructionsSignature } from 'core/components/login/password-creation-instructions';
import { TOC } from '@ember/component/template-only';
import pageTitle from 'ember-page-title/helpers/page-title';
interface Signature {
    Args: {
        model: LoginPasswordCreationInstructionsSignature['Args']['model'];
    };
}
const MedicPasswordForgottenComponent: TOC<Signature> = template(`
  {{pageTitle 'Oubli de mot de passe'}}

  <WrModalContent @targetModal='login-modal' @title='Connexion soignant'>
    <LoginPasswordCreationInstructions @model={{@model}} @userType='medic' />
  </WrModalContent>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(MedicPasswordForgottenComponent);
